import { Component } from '@angular/core';

@Component({
  selector: 'tcc-mono-animal-selection-shell',
  template: `<router-outlet></router-outlet>`,
  styles: [':host {    display: block;  }  ']
})
export class AnimalSelectionShellComponent {}
